<div class="select-company-page">
  <div class="company-card">
    <div class="logo-container">
      <img src="assets/img/logo-projecao-profissional.svg" alt="Logo Projeção Profissional" class="company-logo" />
    </div>
    
    <h1 class="company-title">Selecionar Empresa</h1>
    <p class="company-subtitle">Escolha a empresa que deseja acessar</p>

    <!-- Loading State -->
    <div *ngIf="isLoading && offices.length === 0" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="loading-text">Carregando empresas...</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && offices.length === 0" class="empty-state">
      <mat-icon class="empty-icon">business</mat-icon>
      <h3>Nenhuma empresa encontrada</h3>
      <p>Entre em contato com o administrador do sistema.</p>
    </div>

    <!-- Company Selection -->
    <form *ngIf="offices.length > 0" [formGroup]="companyForm" (ngSubmit)="proceed()" (keydown.enter)="proceed()">
      <!-- Search Filter -->
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Buscar empresa</mat-label>
        <input
          matInput
          type="text"
          formControlName="searchTerm"
          placeholder="Digite o nome da empresa..."
          autocomplete="off"
          data-cy="company-search-input"
        />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Company Cards -->
      <div class="company-cards-container">
        <mat-card 
          *ngFor="let office of filteredOffices" 
          class="company-card-item"
          [class.selected]="companyForm.get('selectedCompany')?.value === office.id"
          (click)="selectCompany(office.id)"
          [attr.data-cy]="'company-card-' + office.id"
        >
          <mat-card-content>
            <div class="company-info">
              <mat-icon class="company-icon">business</mat-icon>
              <div class="company-details">
                <h3 class="company-name">{{ office.name }}</h3>
                <p class="company-description">Clique para selecionar esta empresa</p>
              </div>
              <!-- Indicador visual de seleção -->
              <div class="selection-indicator" *ngIf="companyForm.get('selectedCompany')?.value === office.id">
                <mat-icon>check_circle</mat-icon>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- No Results -->
        <div *ngIf="filteredOffices.length === 0 && searchTerm" class="no-results">
          <mat-icon class="no-results-icon">search_off</mat-icon>
          <h3>Nenhuma empresa encontrada</h3>
          <p>Tente ajustar os termos de busca</p>
        </div>
      </div>

      <button 
        mat-raised-button 
        color="primary" 
        type="submit" 
        [disabled]="companyForm.invalid || isLoading"
        class="company-submit-button"
        data-cy="submit-company"
      >
        <mat-spinner *ngIf="isLoading" diameter="20" class="button-spinner"></mat-spinner>
        <span *ngIf="!isLoading">Avançar</span>
        <span *ngIf="isLoading">Carregando...</span>
      </button>
    </form>
  </div>
</div>
